import { useAtom } from 'jotai';

import { ticketAtom } from '@/pages/Ticket';

import TemplateCustomDataEnvironments from './templates/TemplateCustomDataEnvironments';
import TemplateCustomDataLogsData from './templates/TemplateCustomDataLogsData';
import TemplateCustomDataTravelNotification from './templates/TemplateCustomDataTravelNotification';
import TemplateTicketAttachments from './templates/TemplateTicketAttachments';
import TemplateTicketExternalThreats from './templates/TemplateTicketExternalThreats';

const TicketDetailsDescriptionTemplates = () => {
  const [
    { attachments: ticket_attachments, custom_data, ticket_external_threats }
  ] = useAtom(ticketAtom);

  return (
    <>
      {custom_data?.environments &&
        ((custom_data?.environments.add &&
          custom_data?.environments.add.length !== 0) ||
          (custom_data?.environments.remove &&
            custom_data?.environments.remove.length !== 0)) && (
          <TemplateCustomDataEnvironments />
        )}
      {custom_data?.logs_data && custom_data?.logs_data.action === 1 && (
        <TemplateCustomDataLogsData />
      )}
      {custom_data?.travel_notification && (
        <TemplateCustomDataTravelNotification />
      )}
      {ticket_external_threats && ticket_external_threats?.length > 0 && (
        <TemplateTicketExternalThreats />
      )}
      {ticket_attachments && ticket_attachments?.length > 0 && (
        <TemplateTicketAttachments />
      )}
    </>
  );
};

export default TicketDetailsDescriptionTemplates;
